import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { CustomAutoCompleteModule } from '@module/custom-mat-autocomplete/custom-autocomplete.module';
import { CustomSearchSelectModule } from '@module/custom-mat-search-select/custom-searchselect.module';
import { CommonModule } from '@angular/common';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "ng-pick-datetime";
import { CustomInputTextboxModule } from '@module/custom-input-text/input-text.module';
import { CustomInputTextareaModule } from '@module/custom-input-textarea/input-textarea.module';
import { AppointmentService } from '@service/appointment.service';
import { AppointmentDialogComponent } from './appoinment-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CustomDirectiveModule } from '../../../../directive/custom-directive.module';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CustomAlertStripModule } from '@module/custom-alert-strip/alert-strip.module'

@NgModule({
  declarations: [    
    AppointmentDialogComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    CustomDirectiveModule,
    CommonModule,
    CustomAlertStripModule,
    CustomInputTextboxModule,
    CustomInputTextareaModule,
    CustomAutoCompleteModule,
    CustomSearchSelectModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatInputModule,
    MatSnackBarModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatSelectModule,
    MatRadioModule,
    MatCheckboxModule,
    MatSlideToggleModule
  ],
  providers: [
    AppointmentService
  ],
})

export class AppointmentDialogModule {
}
